export const OPEN_SUBMIT_ART_WORK_MODAL = "OPEN_SUBMIT_ART_WORK_MODAL";
export const CLOSE_SUBMIT_ART_WORK_MODAL = "CLOSE_SUBMIT_ART_WORK_MODAL";
